<h2 mat-dialog-title>Table Settings</h2>
<mat-dialog-content>
    <div cdkDropList [cdkDropListData]="allColumns" (cdkDropListDropped)="drop($event)">
        <div *ngFor="let col of allColumns; trackBy: trackByName" cdkDrag class="draggable-column">
            <mat-checkbox [checked]="displayedColumns.includes(col.name)"
                (change)="toggleColumn(col.name, $event.checked)">
                {{ col.label }}
            </mat-checkbox>
            <mat-icon class="drag-handle" cdkDragHandle>drag_indicator</mat-icon>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-stroked-button (click)="close()">Cancel</button>
    <button mat-raised-button color="primary" (click)="save()">Save</button>
</mat-dialog-actions>